<template>
  <AuthLayout
    pitch-title="Acontece com todo mundo."
    pitch-sub="Informe seu e-mail e enviaremos um link seguro para você redefinir sua senha."
  >
    <ResetPasswordForm :isModal="false" />
  </AuthLayout>
</template>

<script>
import AuthLayout from '../components/ui/AuthLayout.vue';
import ResetPasswordForm from '../modules/person/components/Forms/ResetPasswordForm.vue';

export default {
  name: 'ResetPassword',
  components: {
    AuthLayout,
    ResetPasswordForm,
  },
};
</script>
